<template>
  <section v-if="items.length > 0" class="recommend-viewing-categories">
    <div class="container">
      <div class="recommend-viewing-categories__title h2">Рекомендуем посмотреть</div>
      <div class="recommend-viewing-categories__items">
        <template
          v-for="(item) in items"
          :key="`item-${ item.id }`"
        >
          <nuxt-link
            :to="item.url"
            class="btn btn-small btn-outline"
          >{{ item.name }}</nuxt-link>
        </template>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
const catalogStore = useCatalogStore();
import { getCharacteristicFromFull } from '~/utils/getCharacteristic';
import type { IProduct } from '#sitis/internal/controllers/products/models/Product';
import { catalogStore as useCatalogStore } from '#sitis/stores/modules/catalog-store';


interface IProps {
  product: IProduct | null | undefined;
}
const props = withDefaults(defineProps<IProps>(), {
  product: null
});

const items: ComputedRef<any[]> = computed(() => {
  const char = getCharacteristicFromFull(props.product?.characteristics || [], 'popular_categories');
  if (!char) {
    return []
  }

  let charValue = [];
  try {
    charValue = JSON.parse((char?.values || [])?.[0]?.value || '[]');
  } catch (err) {}
  if (charValue.length <= 0) {
    return []
  }

  const allCategories = catalogStore.$state?.categories || [];
  return [...(charValue)].map((t: any) => {
    return allCategories.find((cat: any) => Boolean(String(cat.id) === String(t)))
  }).filter((t: any) => t);
});
</script>

<style lang="scss">
.recommend-viewing-categories {
  margin-top: 120px;
}
.recommend-viewing-categories__title {
  margin-bottom: 32px;
}
.recommend-viewing-categories__items {
  gap: 16px;
  display: flex;
  flex-wrap: wrap;
}

@media (max-width: 1023px) {
  .recommend-viewing-categories {
    margin-top: 80px;
  }
  .recommend-viewing-categories__title {
    margin-bottom: 16px;
  }
}
</style>
